import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import ButtonIconSecondary from 'components/molecules/buttons/ButtonIconSecondary';

const UpdateWrapper = styled.div`
    background-color: #F2FAFF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 32px;

    ${breakpoint('xs', 'sm')`
       flex-direction: column;
       height: 85px;
    `}
`;

const UpdateBlock = ({ lastExecution, onClick }) => (
    <UpdateWrapper>
        <div>This data was last updated - <b>{lastExecution}</b></div>
        <ButtonIconSecondary
            icon="refresh"
            iconColor="#007DC6"
            onClick={onClick}
        >
            {'Refresh'}
        </ButtonIconSecondary>
    </UpdateWrapper>
);

UpdateBlock.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        value: PropTypes.number.isRequired
    }),
    format: PropTypes.string
};

export default UpdateBlock;



// WEBPACK FOOTER //
// ./src/components/molecules/labs/crossChannel/UpdateBlock.js